import React, { useState, useEffect } from "react";
import DashBoardLayerTwo from "../components/DashBoardLayerTwo";
import useUsersApi from "../api/useUsersApi";

const HomePage = () => {
  const { loading, getDashboardStates } = useUsersApi();
  const [filter, setFilter] = useState("daily");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [states, setStates] = useState(null);

  const formatDate = (date) => date.toISOString().split("T")[0];

  const fetchStates = async () => {
    try {
      let params = { filter };
      
      // Add dates to params if filter is custom
      if (filter === "custom") {
        if (!start_date || !end_date) {
          return; // Don't fetch if dates aren't set for custom filter
        }
        params = {
          filter: "custom",
          start_date,
          end_date
        };
      }
      
      const res = await getDashboardStates(params);
      setStates(res?.data?.payload);
    } catch (error) {
      console.error("Error fetching dashboard states:", error);
    }
  }

  useEffect(() => {
    if (filter === "custom") {
      if (start_date && end_date) {
        fetchStates();
      }
    } else {
      fetchStates();
    }
  }, [filter, start_date, end_date]);

  useEffect(() => {
    const daily = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = daily;
        break;
      case "weekly":
        start = new Date(daily);
        start.setDate(daily.getDate() - 6);
        end = daily;
        break;
      case "monthly":
        start = new Date(daily.getFullYear(), daily.getMonth(), 1);
        end = new Date(daily.getFullYear(), daily.getMonth() + 1, 0);
        break;
      case "yearly":
        start = new Date(daily.getFullYear(), 0, 1);
        end = new Date(daily.getFullYear(), 11, 31);
        break;
      case "custom":
        return; // Don't auto-set dates for custom filter
      default:
        return;
    }

    setStartDate(formatDate(start));
    setEndDate(formatDate(end));
  }, [filter]);

  const handleClear = () => {
    setFilter("daily");
    setStartDate("");
    setEndDate("");
  };

  const handleDateChange = (e, dateType) => {
    const value = e.target.value;
    if (dateType === 'start') {
      setStartDate(value);
      // If end date is before start date, update end date
      if (end_date && value > end_date) {
        setEndDate(value);
      }
    } else {
      // Don't allow end date to be before start date
      if (!start_date || value >= start_date) {
        setEndDate(value);
      }
    }
  };

  return (
    <>
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
        <h6 className='fw-semibold mb-0'>Dashboard</h6>
        <div className="d-flex gap-2 flex-wrap align-items-center">
          <select
            className="form-select form-select-sm w-auto bg-base border text-secondary-light"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="" disabled>Select Frequency</option>
            <option value="yearly">Yearly</option>
            <option value="monthly">Monthly</option>
            <option value="weekly">Weekly</option>
            <option value="daily">Daily</option>
            <option value="custom">Custom</option>
          </select>

          {filter === "custom" && (
            <>
              <input
                type="date"
                className="form-control form-control-sm w-auto"
                value={start_date}
                onChange={(e) => handleDateChange(e, 'start')}
                max={end_date || undefined}
                required
              />
              <span>to</span>
              <input
                type="date"
                className="form-control form-control-sm w-auto"
                value={end_date}
                onChange={(e) => handleDateChange(e, 'end')}
                min={start_date || undefined}
                required
              />
            </>
          )}

          {filter !== "yearly" && (
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <DashBoardLayerTwo
        filter={filter}
        start_date={start_date}
        end_date={end_date}
        states={states} 
        loading={loading}
      />
    </>
  );
};

export default HomePage;
